import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  Sidebar,
  SidebarBody,
  SidebarHeader,
  SidebarSection,
  SidebarItem,
  SidebarLabel,
  SidebarFooter,
  SidebarSpacer,
} from "../components/catalyst/sidebar";
import { Divider } from "../components/catalyst/divider";
import {
  SquarePen,
  List,
  User,
  LogOut,
  Calendar,
  Bookmark,
  Users,
  Map,
  MessageSquare,
  Contact,
} from "lucide-react"; // <-- Added Map, MessageSquare and Contact icons
import { useAuth } from "../contexts/AuthContext";

export function SidebarContent({ closeSidebar }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  // Don't render menu items if user isn't loaded yet
  if (!user) return null;

  const menuItems = [
    // Existing BM items
    { path: "/", label: "Generate", icon: SquarePen, role: "BM" },
    { path: "/build-itinerary", label: "Build Your Own Itinerary", icon: Map, role: "BM" }, // <-- New item added
    { path: "/schedules", label: "View Schedules", icon: List, role: "BM" },
    {
      path: "/saved-schedules",
      label: "Saved Schedules",
      icon: Bookmark,
      role: "BM",
    },
    {
      path: "/saved-byoi",
      label: "Saved BYOI",
      icon: Calendar,
      role: "BM",
    },
    // New BM Item
    { path: "/rsm-manager", label: "RSM Manager", icon: Users, role: "BM" },
    { path: "/manage-engagements", label: "Manage Engagements", icon: MessageSquare, role: "BM" }, // <-- New manage engagements
    // Existing RSM item
    {
      path: "/rsm-schedules",
      label: "My Schedules",
      icon: Calendar,
      role: "RSM",
    },
    // Contact Manager - available to both BM and RSM (temporarily hidden)
    // { path: "/contact-manager", label: "Contact Manager", icon: Contact },
  ];

  return (
    <Sidebar className="h-full">
      <SidebarHeader className="p-4">
        <Link to="/" onClick={closeSidebar}>
          <span className="font-bold text-lg">ISCO CoSailor</span>
        </Link>
      </SidebarHeader>

      <SidebarBody className="p-4">
        <SidebarSection>
          {menuItems
            .filter((item) => !item.role || item.role === user.role)
            .map((item) => {
              const isActive = location.pathname === item.path;
              return (
                <SidebarItem
                  as={Link}
                  to={item.path}
                  key={item.path}
                  onClick={closeSidebar}
                  current={isActive}
                >
                  <item.icon className="h-5 w-5" />
                  <SidebarLabel>{item.label}</SidebarLabel>
                </SidebarItem>
              );
            })}
        </SidebarSection>
        <SidebarSpacer />
      </SidebarBody>

      <SidebarFooter className="p-4">
        <SidebarItem as={Link} to="/profile">
          <User className="h-5 w-5" />
          <SidebarLabel>Profile</SidebarLabel>
        </SidebarItem>
        <SidebarItem
          onClick={() => {
            logout();
            navigate("/login");
          }}
        >
          <LogOut className="h-5 w-5" />
          <SidebarLabel>Logout</SidebarLabel>
        </SidebarItem>
        <Divider className="my-2" />
        <div className="flex items-center justify-center gap-2 text-xs text-zinc-500 dark:text-zinc-400">
          <span>Powered by</span>
          <span className="font-semibold">Instalily</span>
        </div>
      </SidebarFooter>
    </Sidebar>
  );
}
